import React from 'react';
import 'twin.macro';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import request from '@teetsh/app/src/utils/request';
import { ELEVES_TRASH_KEY } from '@teetsh/app/src/containers/UserSettings/Trash/Eleves/useElevesTrash';
import { useTranslation } from 'react-i18next';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { ELEVES_ACCOUNT_KEY } from '@teetsh/app/src/queries/eleves/useEleves';

export function useRestoreEleve() {
  const { notifySuccess, notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['userSettings']);
  const { mutateAsync } = useMutation({
    mutationFn: ({
      id,
      schoolyearId,
      schoolId,
    }: {
      id: string;
      schoolyearId: string;
      schoolId: string;
    }) =>
      request(
        `/schoolyears/${schoolyearId}/schools/${schoolId}/eleves/${id}/restore`,
        { method: 'PATCH' },
      ),
    onSuccess: (_, { id, schoolyearId, schoolId }) => {
      queryClient.invalidateQueries({
        queryKey: [ELEVES_TRASH_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [ELEVES_ACCOUNT_KEY, schoolyearId, schoolId],
      });
      notifySuccess({
        title: t('userSettings:restore.messages.success'),
        message: (
          <ButtonLink
            outlined
            intent="success"
            to={`/annee-scolaire/${schoolyearId}/ecole/${schoolId}/eleves/${id}`} // TODO fix bad redirection even with /general
          >
            {t('userSettings:restore.messages.see')}
          </ButtonLink>
        ),
      });
    },
    onError: () => {
      notifyError({ title: t('userSettings:restore.messages.error') });
    },
  });
  return mutateAsync;
}
